










































































import {
	defineComponent,
	ref,
} from '@vue/composition-api';
import type {
	PropType,
	Ref,
} from '@vue/composition-api';
import type Vue from 'vue';
import type { AxiosError } from 'axios';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { UpsertProgramRequest } from '@front-app/api-generated/learning-management-api';
import { Location } from 'vue-router';
import { useTranslate } from '@front-app/hooks/useTranslate';
import { Size } from '@front-app/components/constants';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import XButton from '@front-app/components/buttons/concrete/XButton.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { LearningProgram } from '../Model';
import { getLearningProgramsStore } from '../store/LearningProgramsStore';
import PublishInfo from './PublishInfo.vue';
import LearningMeta from '../components/LearningMeta.vue';

export default defineComponent({
	components: {
		SimpleCard,
		PublishInfo,
		XButton,
		LearningMeta,
	},
	props: {
		to: {
			type: Object as PropType<Location>,
			required: true,
		},
		program: {
			type: Object as PropType<LearningProgram>,
			required: true,
		},
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const programsStore = getLearningProgramsStore();
		const el: Ref<null | Vue> = ref(null);
		const handleClick = () => {
			ctx.root.$router.push(props.to);
		};
		const handleMiddleClick = (e: MouseEvent) => {
			e.preventDefault();
			const url = ctx.root.$router.resolve(props.to);
			window.open(url.href, '_blank');
		};

		const { track, isLoading, isError } = useAsyncStatus();
		const updateProgram = async (updates: UpsertProgramRequest) => {
			await track(programsStore.updateProgram(props.groupId, props.program.id, updates));
		};

		const $t = useTranslate(ctx);
		const deleteStatus = useAsyncStatus();
		const isUndeletableWarning = ref(false);
		const deleteProgram = () => {
			// eslint-disable-next-line no-alert
			const shouldDelete = window.confirm($t('lms.admin.confirm-delete-program') as unknown as string);
			if (shouldDelete) {
				isUndeletableWarning.value = false;
				deleteStatus.track(programsStore.deleteProgram(props.groupId, props.program.id)
					.catch((a: AxiosError) => {
						isUndeletableWarning.value = a.response?.status === 406;
					}));
			}
		};

		return {
			el,
			isLoading,
			isError,
			updateProgram,
			handleClick,
			handleMiddleClick,
			removeButtonSize: Size.INLINE,
			publishDropdownPosition: DropdownPosition.BOTTOM_LEFT,
			deleteProgram,
			isUndeletableWarning,
			isErrorDeleting: deleteStatus.isError,
			isAttemptingDelete: deleteStatus.isLoading,
		};
	},
});
